import React from 'react'

import StarRatingComponent from 'react-star-rating-component'
import { Star, HalfStar, EmptyStar } from './StarItem'

const StarReviewComponent = ({ onStarClick, value, ...props }) => (
  <StarRatingComponent
    {...props}
    value={+value}
    onStarClick={(nextValue, prevValue, name, e) => {
      // this is for support half star rating values
      // const xPos =
      //   (e.pageX - e.currentTarget.getBoundingClientRect().left) /
      //   e.currentTarget.offsetWidth

      // if (xPos <= 0.5) {
      //   nextValue -= 0.5
      // }
      onStarClick(nextValue, prevValue, name, e)
    }}
    renderStarIcon={(index, value) =>
      index <= value ? <Star /> : <EmptyStar />
    }
    renderStarIconHalf={(index, value) => <HalfStar />}
  />
)

export default StarReviewComponent



// WEBPACK FOOTER //
// ./src/components/StarReviewComponent/index.js